import { render, staticRenderFns } from "./NotificacionesPage.vue?vue&type=template&id=c04f6346"
import script from "./NotificacionesPage.vue?vue&type=script&lang=ts"
export * from "./NotificacionesPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports